import { BaseConfig } from "../config.interface";

interface IFileUploadListConfig {
    /**
     * Label of the element.
     */
    label?: string;
    orientation: "vertical" | "horizontal" | "mixed";
}


export class FileUploadListConfig extends BaseConfig<IFileUploadListConfig > implements IFileUploadListConfig  {
    /**
     * Label of the element.
     */
    label?: string;
    orientation: "vertical" | "horizontal" | "mixed";
    /**
     * @theme Base
     */
    static baseTheme = {
        Default: new FileUploadListConfig({
            orientation: 'vertical',
        }),
        Mixed: new FileUploadListConfig({
            orientation: 'mixed',
        }),

    };

}
